import {useArtist} from '@app/web-player/artists/requests/use-artist';
import {ArtistPageHeader} from '@app/web-player/artists/artist-page/artist-page-header';
import {PageMetaTags} from '@common/http/page-meta-tags';
import {PageStatus} from '@common/http/page-status';
import React, {useContext, useEffect} from 'react';
import {ArtistPageTabs} from '@app/web-player/artists/artist-page/artist-page-tabs';
import {useLogEvent, useLogEventProps} from '@common/core/event-logger';
import {AdPageItem} from '@app/web-player/ads/ad-page-item';
import {AdHost} from '@common/admin/ads/ad-host';
import {DialogContext} from '@ui/overlays/dialog/dialog-context';
import ChannelNavbar from '@app/web-player/channels/channel-navbar';
import {isMobileApp} from '@common/core/platform-detection';
import {NotificationDialogTrigger} from '@common/notifications/dialog/notification-dialog-trigger';
import clsx from 'clsx';
import {useIsMobileMediaQuery} from '@ui/utils/hooks/is-mobile-media-query';

export function ArtistPage({artist}: any) {
  const query = useArtist(
    artist
      ? {loader: 'artistPage', artistId: artist.id}
      : {loader: 'artistPage'},
  );
  const eventPayload: useLogEventProps = {
    event_type: 'view',
    entity_id: query.data?.artist.id,
    entity_type: 'artist',
    metadata: {artist: query.data?.artist},
  };
  const ctx = useContext(DialogContext);
  const isMobile = useIsMobileMediaQuery();
  const isNativeApp = isMobileApp();

  useLogEvent(eventPayload); // ✅ Appelle la fonction normale ici

  if (query.data) {
    return (
      <>
        {!ctx && isMobile && (
          <ChannelNavbar
            fixed={true}
            background={isNativeApp ? 'transparent' : 'bg'}
            className={isNativeApp ? 'app-ambient-channel-header' : undefined}
          >
            <div
              className={clsx(
                'mb-16 flex items-center justify-end gap-24 md:mb-20',
              )}
            >
              {isMobile ? (
                <div className="flex flex-shrink-0 items-end gap-2">
                  <NotificationDialogTrigger />
                </div>
              ) : null}
            </div>
          </ChannelNavbar>
        )}
        <div className={!ctx && isMobile ? 'mt-64' : ''}>
          <AdHost slot="general_top" className="mb-44" />
          <PageMetaTags query={query} />
          <ArtistPageHeader artist={query.data.artist} />
          <AdHost slot="artist_top" className="mb-44" />
          <ArtistPageTabs data={query.data} />
          <AdHost slot="general_bottom" className="mt-44" />
          <AdPageItem object="artist" className={'mt-44'}></AdPageItem>
        </div>
      </>
    );
  }

  return (
    <PageStatus
      query={query}
      loaderClassName="absolute inset-0 m-auto"
      loaderIsScreen={false}
    />
  );
}
